import { gsap } from "gsap";
import { Container, IDestroyOptions, Point, Sprite, Texture } from "pixi.js";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { StarsResourcePackage } from "../../../common/resources/StarsResourcePackage";
import { DicesResourcePackage } from "../../../common/resources/DicesResourcePackage";
type TimeLine = gsap.core.Timeline;

export class DicesBackground extends Container {
    private readonly ICONS_VIEW_DESCRIPTION = new Array<IconViewDescription>();
    private readonly referenceWidth: number;
    private readonly referenceHeight: number;
    private dollarIcons: Array<Sprite>;
    private iconIdleAnimation: TimeLine;

    public constructor(
        commonResources: CommonResourcesPackage,
        starsResources: StarsResourcePackage,
        dicesResources: DicesResourcePackage,
        referenceWidth: number,
        referenceHeight: number
    ) {
        super();
        this.referenceWidth = referenceWidth;
        this.referenceHeight = referenceHeight;
        this.iconIdleAnimation = new gsap.core.Timeline();
        this.ICONS_VIEW_DESCRIPTION = new Array<IconViewDescription>(
            { percentPosition: new Point(-0.095, 0.503), texture: starsResources.assets_views_stars_2_png, angle: 3, positiveScaleDifferent: 0.25 },
            { percentPosition: new Point(-0.05, 0.21), texture: starsResources.assets_views_stars_14_png, angle: -10.48 },
            { percentPosition: new Point(-0.109, 0.05), texture: starsResources.assets_views_stars_1_png },
            { percentPosition: new Point(0.55, -0.008), texture: starsResources.assets_views_stars_13_png, angle: 141, positiveScaleDifferent: 0.044 },
            { percentPosition: new Point(0.96, -0.105), texture: starsResources.assets_views_stars_13_png, angle: 84 },
            { percentPosition: new Point(0.95, 0.073), texture: starsResources.assets_views_stars_1_png },
            { percentPosition: new Point(0.883, 0.15), texture: starsResources.assets_views_stars_7_png, angle: 23 },
            { percentPosition: new Point(0.963, 0.472), texture: starsResources.assets_views_stars_5_png, positiveScaleDifferent: 0.34 },

            { percentPosition: new Point(-0.19, 0.57), texture: commonResources.assets_common_ui_dices_dice_03_png },
            { percentPosition: new Point(-0.185, 0.236), texture: dicesResources.assets_views_dices_dice_04_png, angle: 7.24 },
            { percentPosition: new Point(-0.135, 0.073), texture: dicesResources.assets_views_dices_dice_07_png },
            { percentPosition: new Point(0.26, -0.109), texture: commonResources.assets_common_ui_dices_dice_01_png, positiveScaleDifferent: 0.185 },
            { percentPosition: new Point(0.8, -0.021), texture: dicesResources.assets_views_dices_dice_06_png },
            { percentPosition: new Point(0.848, 0.108), texture: commonResources.assets_common_ui_dices_dice_03_png },
            { percentPosition: new Point(1.223, 0.26), texture: dicesResources.assets_views_dices_dice_05_png, angle: 85.35 },
            { percentPosition: new Point(0.938, 0.55), texture: dicesResources.assets_views_dices_dice_02_png },

            { percentPosition: new Point(0.255, 0.07), texture: dicesResources.assets_views_dices_dice_08_png },
            { percentPosition: new Point(0.606, 0.079), texture: dicesResources.assets_views_dices_dice_09_png }
        );
        this.dollarIcons = [];
        this.build();
    }

    private build(): void {
        this.ICONS_VIEW_DESCRIPTION.forEach((item) => {
            const icon = new Sprite(item.texture);
            if (item.angle) {
                icon.angle = item.angle;
            }
            if (item.positiveScaleDifferent) {
                icon.scale.x += item.positiveScaleDifferent;
                icon.scale.y += item.positiveScaleDifferent;
            }
            icon.position.set(this.referenceWidth * item.percentPosition.x - this.referenceWidth * 0.5, this.referenceHeight * item.percentPosition.y - this.referenceHeight * 0.5);
            this.dollarIcons.push(icon);
            this.addChild(icon);
        });
    }

    public async playIdleAnimation(): Promise<void> {
        this.dollarIcons.forEach((icon) => {
            this.iconIdleAnimation.to(icon, {
                x: "+=25",
                y: `random(${icon.y - 20}, ${icon.y + 20}, 1)`,
                duration: "random(1.5, 2)",
                delay: "random(0, 0.2)",
                repeat: -1,
                repeatRefresh: true,
                yoyo: true,
                ease: "sine.inOut"
            }, "<");
        });
        await this.iconIdleAnimation.play();
        this.iconIdleAnimation.clear();
    }

    public hide(): void {
        this.iconIdleAnimation.pause(0);
        this.iconIdleAnimation.clear();
        this.visible = false;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.iconIdleAnimation.kill();
        super.destroy(options);
    }
}

type IconViewDescription = {
    percentPosition: Point;
    texture: Texture;
    angle?: number;
    positiveScaleDifferent?: number;
}
